/**
 * Public, login-free view of the Brand kit at /brand-kit/share — for
 * partners, agencies, printers and press. Same component as the
 * internal page, wrapped in a slim LampTwist header/footer instead of
 * the mosy app shell. Nothing here touches the API: the copy and the
 * logo files are static, so exposing the page leaks nothing else.
 */
import { useEffect } from 'react';
import BrandKit from './BrandKit';

const STYLES = `
.bk-public { min-height: 100vh; background: var(--bg); color: var(--ink); display: flex; flex-direction: column; }
.bk-public-bar { background: #2B4138; color: #F1F0E8; }
.bk-public-bar-inner { max-width: 1320px; margin: 0 auto; padding: 14px 28px; display: flex; justify-content: space-between; align-items: center; gap: 20px; }
.bk-public-bar img { height: 26px; display: block; filter: brightness(0) invert(1); }
.bk-public-bar .tag { font-size: 12.5px; letter-spacing: 0.08em; text-transform: uppercase; opacity: 0.8; font-weight: 600; }
.bk-public-content { flex: 1; padding: 28px 28px 60px; }
.bk-public-content-inner { max-width: 1320px; margin: 0 auto; }
.bk-public-footer { border-top: 1px solid var(--border); color: var(--ink-4); font-size: 12.5px; }
.bk-public-footer-inner { max-width: 1320px; margin: 0 auto; padding: 18px 28px; display: flex; justify-content: space-between; gap: 12px; flex-wrap: wrap; }
.bk-public-footer a { color: inherit; }
@media (max-width: 640px) { .bk-public-bar-inner, .bk-public-content, .bk-public-footer-inner { padding-inline: 16px; } .bk-public-bar .tag { display: none; } }
`;

const PublicBrandKit = () => {
  useEffect(() => {
    const prev = document.title;
    document.title = 'LampTwist · Brand kit';
    return () => {
      document.title = prev;
    };
  }, []);

  return (
    <div className="bk-public">
      <style>{STYLES}</style>
      <header className="bk-public-bar">
        <div className="bk-public-bar-inner">
          <a href="https://lamptwist.com" target="_blank" rel="noreferrer" aria-label="LampTwist">
            <img src="/lamptwist-wordmark.svg" alt="LampTwist" />
          </a>
          <span className="tag">Brand kit</span>
        </div>
      </header>
      <main className="bk-public-content">
        <div className="bk-public-content-inner">
          <BrandKit publicView />
        </div>
      </main>
      <footer className="bk-public-footer">
        <div className="bk-public-footer-inner">
          <span>© LampTwist · Chaussée de Waterloo 1357A, 1180 Uccle · Brussels</span>
          <span>
            <a href="https://lamptwist.com" target="_blank" rel="noreferrer">lamptwist.com</a>
            {' · '}
            <a href="https://b2b.lamptwist.com" target="_blank" rel="noreferrer">b2b.lamptwist.com</a>
          </span>
        </div>
      </footer>
    </div>
  );
};

export default PublicBrandKit;
